import React from "react";

interface UploadIconProps {
  size?: number;
}

const UploadIcon: React.FC<UploadIconProps> = ({ size = 16 }) => {
  return (
    <div style={{ width: `${size}px`, height: `${size}px` }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M0.5 10.4536C0.632608 10.4536 0.759785 10.5063 0.853553 10.6001C0.947322 10.6938 1 10.821 1 10.9536V13.4536C1 13.7188 1.10536 13.9732 1.29289 14.1607C1.48043 14.3483 1.73478 14.4536 2 14.4536H14C14.2652 14.4536 14.5196 14.3483 14.7071 14.1607C14.8946 13.9732 15 13.7188 15 13.4536V10.9536C15 10.821 15.0527 10.6938 15.1464 10.6001C15.2402 10.5063 15.3674 10.4536 15.5 10.4536C15.6326 10.4536 15.7598 10.5063 15.8536 10.6001C15.9473 10.6938 16 10.821 16 10.9536V13.4536C16 13.984 15.7893 14.4928 15.4142 14.8678C15.0391 15.2429 14.5304 15.4536 14 15.4536H2C1.46957 15.4536 0.960859 15.2429 0.585786 14.8678C0.210714 14.4928 0 13.984 0 13.4536V10.9536C0 10.821 0.0526784 10.6938 0.146447 10.6001C0.240215 10.5063 0.367392 10.4536 0.5 10.4536Z"
          fill="#C4C6CD"
        />
        <path
          d="M7.64614 1.69963C7.69259 1.65306 7.74776 1.61612 7.80851 1.59092C7.86926 1.56571 7.93438 1.55273 8.00014 1.55273C8.06591 1.55273 8.13103 1.56571 8.19178 1.59092C8.25252 1.61612 8.3077 1.65306 8.35414 1.69963L11.3541 4.69963C11.448 4.79351 11.5008 4.92085 11.5008 5.05363C11.5008 5.1864 11.448 5.31374 11.3541 5.40763C11.2603 5.50151 11.1329 5.55426 11.0001 5.55426C10.8674 5.55426 10.74 5.50151 10.6461 5.40763L8.50014 3.26063V12.0536C8.50014 12.1862 8.44747 12.3134 8.3537 12.4072C8.25993 12.5009 8.13275 12.5536 8.00014 12.5536C7.86754 12.5536 7.74036 12.5009 7.64659 12.4072C7.55282 12.3134 7.50014 12.1862 7.50014 12.0536V3.26063L5.35414 5.40763C5.30766 5.45412 5.25247 5.49099 5.19173 5.51615C5.13099 5.54131 5.06589 5.55426 5.00014 5.55426C4.9344 5.55426 4.8693 5.54131 4.80856 5.51615C4.74782 5.49099 4.69263 5.45412 4.64614 5.40763C4.59966 5.36114 4.56278 5.30595 4.53762 5.24521C4.51246 5.18447 4.49951 5.11937 4.49951 5.05363C4.49951 4.98788 4.51246 4.92278 4.53762 4.86204C4.56278 4.80131 4.59966 4.74612 4.64614 4.69963L7.64614 1.69963Z"
          fill="#C4C6CD"
        />
      </svg>
    </div>
  );
};

export default UploadIcon;
